/**
 * Woher die eigenen Daten kommen.
 *
 * Im Browser liegt die App auf demselben Host wie Kacheln, Schrift, Symbole,
 * Radarbilder und Ortsprognosen - dort genügen relative Pfade, und dieselbe
 * Ausspielung funktioniert unter `maps.kgva` wie unter `maps.kgva.ch`, ohne
 * neu zu bauen.
 *
 * In der Android-App ist das anders: die Oberfläche liegt im Paket und läuft
 * unter `https://localhost`. Ein relativer Pfad zeigte dort ins Paket, wo
 * keine Kachel liegt. `VITE_DATEN_BASIS` setzt deshalb für diesen Bau eine
 * volle Adresse davor.
 */
const BASIS = (import.meta.env?.VITE_DATEN_BASIS || '').replace(/\/+$/, '');

/** Relativen Pfad auf die Datenbasis beziehen; volle Adressen bleiben, wie sie sind. */
export function mitBasis(pfad) {
  if (!pfad || /^[a-z]+:\/\//i.test(pfad)) return pfad;
  const p = pfad.startsWith('/') ? pfad : `/${pfad}`;
  return BASIS + p;
}

export { BASIS };
